module.exports = __webpack_public_path__ + "img/Charger.ef9106f1.png";